import { useQueryState } from 'nuqs'
import { type PropsWithChildren, useState } from 'react'

import useShelfDetails from '@components/shelfDetails/useShelfDetails'
import { useTodoList } from '@state/todoList.ts'
import { type FilterAndSort, FilterAndSortWrapper, TodoItemWrapper } from '@state/util/todoList'

import TodoListContext, { type TodoListContext as ProductFinderContextType } from './Context'

// we want parser/serializer to be stable
function parseFilterAndSort(value: string): FilterAndSortWrapper {
  return FilterAndSortWrapper.parse(value)
}

function serializeFilterAndSort(value: FilterAndSortWrapper): string {
  return value.toString()
}

function TodoListProvider({ children }: PropsWithChildren) {
  const [filterAndSort, setFilterAndSort] = useQueryState('filterAndSort', {
    defaultValue: new FilterAndSortWrapper(),
    parse: parseFilterAndSort,
    serialize: serializeFilterAndSort,
    history: 'replace',
  })

  const [selectedTask, setSelectedTask] = useState<TodoItemWrapper | undefined>(undefined)
  const { shelfId, setShelfId } = useShelfDetails()

  const { data: filteredTodoList = [] } = useTodoList(filterAndSort)

  const value: ProductFinderContextType = {
    filterAndSort,
    filteredTodoList,
    updateFilterAndSort: (source: Partial<FilterAndSort>) => {
      setFilterAndSort(new FilterAndSortWrapper({
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        ...filterAndSort,
        ...source,
      }))
    },
    selectedTask,
    setSelectedTask,
    selectedShelfId: shelfId,
    setSelectedShelfId: setShelfId,
  }

  return (
    <TodoListContext.Provider value={value}>
      {children}
    </TodoListContext.Provider>
  )
}

export default TodoListProvider